import { defineComponent } from 'vue';
import Catalog from '~/components/Catalog.vue';
import { tradeAreaClient } from '~/lib/client';
import FullscreenSpinner from '~/components/FullscreenSpinner.vue';
import { store } from '~/store';
export default defineComponent({
    name: 'TradeAreaWC',
    components: { Catalog, FullscreenSpinner },
    props: {
        category: {
            type: String,
            default: null,
        },
        brand: {
            type: String,
            default: null,
        },
    },
    computed: {
        spinning() {
            return store.state.spinning;
        }
    },
    methods: {
        async goToSingleProject(product) {
            store.commit('setSpinner', true);
            const permalink = await tradeAreaClient.getWCProductPermalink(product.id);
            if (window.matchMedia('(max-width: 460px)').matches) {
                store.commit('setSpinner', false);
            }
            if (permalink.permalink === null) {
                console.warn(`No product #${product.id} found`);
                return;
            }
            location.assign(permalink.permalink);
        }
    }
});
